import '../../../styles/Blog.css'
type blogHeading = {
    heading: string,
}
function BlogHeading(props: blogHeading) {
    return (
        <h1 className="blog-heading-component">{props.heading}</h1>
    )
}

export default BlogHeading;
